import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=35a47f61&"
import script from "./Presentation.vue?vue&type=script&lang=ts&"
export * from "./Presentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a47f61')) {
      api.createRecord('35a47f61', component.options)
    } else {
      api.reload('35a47f61', component.options)
    }
    module.hot.accept("./Presentation.vue?vue&type=template&id=35a47f61&", function () {
      api.rerender('35a47f61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/admission/Presentation.vue"
export default component.exports